import React from 'react';
import { Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';

const AddButton = ({ onClick }) => (
  <Button type="default" icon={<PlusOutlined />} onClick={onClick} />
);

export default AddButton;